var youtubesetsource = {
    init: function () {
        document.getElementById('iframe').src = "https://www.youtube-nocookie.com/embed/dsZFWYrcXQM";
    }
}